module.exports = __webpack_public_path__ + "img/Insta.27edd75f.svg";